// servicios/inventarios/application/obtenerInventarioInicial.usecase.js
import { obtenerInventarioInicial } from "../infrastructure/supabase/procesoInventarioInicial.repository.js";

export async function obtenerInventarioInicialUseCase() {
  try {
    const result = await obtenerInventarioInicial(); // trae { success, data }
    
    if (!result.success) {
      console.warn("⚠ No se pudieron obtener inventarios:", result.error);
      return [];
    }

    if (!Array.isArray(result.data)) {
      console.warn("[application.obtenerInventarioInicialUseCase] Response no es array, devolviendo vacío");
      return [];
    }

    console.log("[application.obtenerInventarioInicialUseCase] inventario cargado correctamente:", result.data);
    return result.data;
    
  } catch (error) {
    console.error("[application.obtenerInventarioInicialUseCase] Error servicio listando inventario inicial:", error.message, error);
    return [];
  }
}